import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Admissions from "@/pages/Admissions";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";
import AdminDesk from "@/pages/AdminDesk";
import AdminNews from "@/pages/AdminNews";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/admissions" element={<Admissions />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/admin/desk" element={<AdminDesk />} />
        <Route path="/admin/news" element={<AdminNews />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingCTA />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <MotionConfig reducedMotion="user">
        <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </ReactLenis>
      </MotionConfig>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
